module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/electric-744cdef59d88d1a633ffb07e232a1019.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/electric.svg
// module id = NmGw
// module chunks = 24